import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

interface SitemapSection {
  title: string;
  links: {
    text: string;
    url: string;
    isExternal?: boolean;
    type?: 'link' | 'pdf';
  }[];
}

@Component({
  selector: 'app-sitemap-grid',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './sitemap-grid.component.html',
  styleUrls: ['./sitemap-grid.component.scss']
})
export class SitemapGridComponent {
  sections: SitemapSection[] = [
    {
      title: 'Acerca de Unipay',
      links: [
        { text: 'Sobre Unipay', url: '/sobre-unipay' },
        { text: 'Beneficios', url: '/beneficios' },
        { text: 'Invita y gana', url: '/invita-y-gana' },
        { text: 'Servicios', url: '/servicios' }
      ]
    },
    {
      title: 'Productos',
      links: [
        { text: 'Todos los productos', url: '/productos' },
        { text: 'Avance en efectivo', url: '/productos/avance' },
        { text: 'Super avance', url: '/productos/super-avance' },
        { text: 'Solicitar Unipay', url: '/productos/solicitar' }
      ]
    },
    {
      title: 'Sitios Relacionados',
      links: [
        { text: 'Unimarc', url: '/tiendas/unimarc' },
        { text: 'Mayorista 10', url: '/tiendas/mayorista10' },
        { text: 'Alvi', url: '/tiendas/alvi' },
        { text: 'Unired', url: '#' },
      ]
    },
    {
      title: 'Cuenta',
      links: [
        { text: 'Administra tu cuenta', url: '/cuenta' },
        { text: 'Estado de cuenta', url: '/cuenta/estado' },
        { text: 'Pagar estado cuenta', url: '/cuenta/pagar' },
        { text: 'Movimientos', url: '/cuenta/movimientos' }
      ]
    },
    {
      title: 'Servicios de la tienda',
      links: [
        { text: 'Encuentra tu pedido', url: '/servicios/pedido' },
        { text: 'Financiamiento', url: '/servicios/financiamiento' },
        { text: 'Ayuda para comprar', url: '/servicios/ayuda' },
        { text: 'Contacto', url: '/servicios/contacto' }
      ]
    },
    {
      title: 'Ayuda y soporte',
      links: [
        { text: 'Preguntas frecuentes', url: '/preguntas-frecuentes' },
        { text: 'WhatsApp', url: '/soporte/whatsapp' },
        { text: 'Teléfono de contacto', url: '/soporte/telefono' },
        { text: 'Módulos de atención', url: '/soporte/modulos' }
      ]
    },
    {
      title: 'Informaciones',
      links: [
        { text: 'Bases legales', url: '/bases-legales' },
        { text: 'Ganadores y Sorteos', url: '/ganadores-y-sorteos' },
        { text: 'Informacion Corporativa', url: '/informaciones' },
        { text: 'Portabilidad Financiera', url: 'https://www.unipay.cl/portabilidad/validacion' , isExternal: true, type:'link'},
        { text: 'Estadistica Ley 20.009', url: '/estadistica-ley' },
        { text: 'Canal de denuncias', url: 'https://www.denunciasunicard.cl', isExternal: true, type: 'link' },
        { text: 'Términos y condiciones', url: 'https://www.unipay.cl/api/descargaArchivo/20240806_TyC_PdePUnicard_TyC_PdPClubAhorro_VF.pdf', isExternal: true , type:'pdf'},
        { text: 'Política de Habitualidad', url: 'https://www.unipay.cl/api/descargaArchivo/politica_habitualidad_unicard.pdf', isExternal: true , type:'pdf'},
        { text: 'Reporte Operaciones Empresas Relacionadas', url: 'https://www.unipay.cl/api/descargaArchivo/20250131_ReporteOperacionesEmpresasRelacionadasUnicardfcc.pdf', isExternal: true , type:'pdf'}
      ]
    },
    {
      title: 'Valores de Unipay',
      links: [
        { text: 'Medio ambiente', url: '/valores/medio-ambiente' },
        { text: 'Accesibilidad', url: '/valores/accesibilidad' },
        { text: 'Privacidad', url: '/valores/privacidad' },
        { text: 'Responsabilidad social', url: '/valores/responsabilidad' }
      ]
    }
  ];
}
